<template>
    <div class="page-container">
        <el-form :inline="true" class="demo-form-inline toolbar" style="padding-bottom:0px;">
            <el-form-item>
			    <kt-button type="warning" icon="el-icon-back"  label="返回"  @click="goBack()"/>
		    </el-form-item>
        </el-form>
        <div class="content">
            <el-form :model="serviceForm" label-width="85px" :rules="serviceRules" ref="serviceForm" :size="size" label-position="right" class="serviceForm">
            <table>
                <thead>
                     <tr style="height:60px;text-align:center;">
                        <td colspan="6" style="font-size:16px;font-weight:600;" v-if="this.serviceId">修改服务项目</td>
                        <td colspan="6" style="font-size:16px;font-weight:600;" v-else>新增服务项目</td>
                    </tr>
                </thead>
                <tbody>
                    <tr style="height:60px;text-align:center;">
                        <td style="font-size:14px;font-weight:600;">服务项目名称</td>
                        <td colspan="2" class="serviceTypeName">
                            <el-form-item label="" prop="serviceName">
                                <el-input v-model.trim="serviceForm.serviceName" style="width:50%;" auto-complete="off" placeholder="请输入服务项目名称" @change="changeServiceTypeName"></el-input>
                            </el-form-item>
                        </td>
                        <td style="font-size:14px;font-weight:600;">服务类型</td>
                        <td colspan="2" class="serviceType">
                            <el-form-item label="" prop="serviceType">
                                <el-select v-model="serviceForm.serviceType" placeholder="服务类型" style="width:50%" @change="changeServiceType">
                                    <el-option
                                        v-for="item in serviceTypeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>    
                            </el-form-item>
                        </td>  
                    </tr>
                    <tr style="height:60px;text-align:center;">
                        <td style="font-size:14px;font-weight:600;">积分</td>
                        <td colspan="2" class="integral">
                            <el-form-item label="" prop="integral">
                                <el-input v-model.trim="serviceForm.integral" style="width:50%;" auto-complete="off" placeholder="请输入积分" @blur="blurIntegral"></el-input>
                            </el-form-item>
                        </td>
                        <td style="font-size:14px;font-weight:600;">备注</td>
                        <td colspan="2" class="remark">
                            <el-form-item label="" prop="remark">
                                <el-input v-model.trim="serviceForm.remark" type="textarea" :rows="2" auto-complete="off" placeholder="请输入备注" style="width:50%" @blur="blurRemark"></el-input>
                            </el-form-item>
                        </td>
                    </tr>
                    <tr style="height:60px;text-align:center;">
                        <td colspan="6" style="font-size:16px;font-weight:600;">服务流程</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="6" style="font-size:14px;font-weight:600;">
                            <el-row>
                                <el-col :span=2>
                                    <el-steps direction="vertical" :active="this.serviceId ? 7 : stepActive" style="padding:20px 30px; height:600px;width:100%;">
                                        <el-step title="开始"></el-step>
                                        <el-step title="下单"></el-step>
                                        <el-step title="接单" ></el-step>
                                        <el-step title="签到"></el-step>
                                        <el-step title="服务"></el-step>
                                        <el-step title="签退"></el-step>
                                        <el-step title="确认"></el-step>
                                    </el-steps>
                                </el-col>
                                <el-col :span=22 style="padding:107px 15px 40px 15px;">
                                    <el-row style="padding-bottom:25px;">
                                        <el-form-item prop="orderPut" label="角色名称" class="checkbox">
                                            <el-checkbox-group v-model="serviceForm.orderPut" @change="handleCheckedOrderPut">
                                               <el-checkbox v-for="(role,i) in roleOptions" :label="role.roleCode" :key="i" v-show="role.roleCode=='admin'">{{role.roleName}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-row>
                                    <!-- 接单的超时时长 -->
                                    <el-row style="padding:30px 0px 0px 0px;">
                                        <el-form-item prop="orderRecv" label="角色名称" class="checkbox"> 
                                            <el-checkbox-group v-model="serviceForm.orderRecv" @change="handleCheckedOrderRecv">
                                               <el-checkbox v-for="(role,i) in roleOptions" :label="role.roleCode" :key="i" v-show="role.roleCode=='volunteer'">{{role.roleName}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-row>
                                    <el-row style="line-height:36px;">
                                        <el-form-item prop="durationRecv" label="超时时长" class="selectItem">
                                            <el-select v-model="serviceForm.durationRecv" placeholder="请选择超时时长" style="width:20%" @change="changeDurationRecv">
                                                <el-option
                                                    v-for="item in receivingOrderoverTimeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select> 
                                            <span>分钟</span>
                                        </el-form-item> 
                                    </el-row>
                                    <!-- 签到的超时时长 -->
                                    <el-row style="padding:20px 0px 25px 0px;line-height:36px;">
                                        <el-form-item prop="durationIn" label="超时时长" class="selectItem">
                                            <el-select v-model="serviceForm.durationIn" placeholder="请选择超时时长" style="width:20%" @change="changeDurationIn">
                                                <el-option
                                                    v-for="item in overTimeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>  
                                            <span>分钟</span>
                                        </el-form-item>
                                    </el-row>
                                    <!-- 服务的超时时长 -->
                                    <el-row style="padding:35px 0px 0px 0px;line-height:36px;">
                                        <el-col><span style="color:#f56c6c;margin-right: 4px;">*</span><kt-button icon="" label="服务内容" type="text" @click="addserviceProcessDialog"/></el-col>
                                    </el-row>
                                    <!-- 添加display:none 隐藏  暂时去掉服务超时时长 -->
                                    <el-row style="line-height:36px;display:none;">
                                        <el-form-item prop="durationService" label="超时时长" class="selectItem">
                                            <el-select v-model="serviceForm.durationService" placeholder="请选择超时时长" style="width:20%" @change="changeDurationService">
                                                <el-option
                                                    v-for="item in overTimeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select> 
                                            <span>分钟</span>
                                        </el-form-item> 
                                    </el-row>
                                    <!-- 签退的超时时长 -->
                                    <el-row style="padding:59px 0px 20px 0px;line-height:36px;">
                                        <el-form-item prop="durationOut" label="超时时长" class="selectItem">
                                            <el-select v-model="serviceForm.durationOut" placeholder="请选择超时时长" style="width:20%" @change="changeDurationOut">
                                                <el-option
                                                    v-for="item in overTimeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <span>分钟</span>
                                        </el-form-item> 
                                    </el-row>
                                    <!-- 确认超时时长 -->
                                    <el-row style="padding:38px 0px 0px 0px;line-height:36px;">
                                        <el-form-item prop="orderConfirm" label="角色名称" class="checkbox">
                                            <el-checkbox-group v-model="serviceForm.orderConfirm" @change="handleCheckedOrderConfirm">
                                               <el-checkbox v-for="(role,i) in roleOptions" :label="role.roleCode" :key="i" v-show="role.roleCode=='admin'">{{role.roleName}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-row>
                                    <el-row style="line-height:36px;">
                                        <el-form-item prop="durationConfirm" label="超时时长" class="selectItem">
                                            <el-select v-model="serviceForm.durationConfirm" placeholder="请选择超时时长" style="width:20%" @change="changeDurationConfirm">
                                                <el-option
                                                    v-for="item in overTimeOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select> 
                                            <span>分钟</span>
                                        </el-form-item> 
                                    </el-row>
                                </el-col>
                            </el-row>
                        </td>
                    </tr>
                </tfoot>
            </table>
            </el-form>
            <div slot="footer" class="dialog-footer" align=center>
                <el-button :size="size" @click.native="reset" v-if="!this.serviceId">重置</el-button>
                <el-button :size="size" type="primary" @click.native="submitService" :loading="editLoading">保存</el-button>
            </div>
        </div>
         <!-- 巡查服务流程dialog模态框-->
        <el-dialog class="serviceProcessdialog" title="巡查服务流程" width="45%" :visible.sync="serviceProcessDialogVisible" :close-on-click-modal="false">
             <div align="right" style="margin-bottom:10px;">
			    <!-- <kt-button icon="el-icon-circle-plus" label="新增" type="primary" @click="addProcess" :disabled="isDisabled"/> -->
                <el-button icon="el-icon-circle-plus" type="primary" @click="addProcess" :disabled="isDisabled">新增</el-button>
		    </div>
            <el-table :data="serviceProcessList" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
                <el-table-column style="height:65px;" label="流程顺序" align="center">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务内容名称" style="height:65px;" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span  v-if="!scope.row.editeFlage" style="margin-left: 10px">{{ scope.row.itemName }}</span>
                        <input type="text" class="el-input__inner" v-if="scope.row.editeFlage" style="width:120px;" v-model.trim="scope.row.itemName"  placeholder="请输入" @input="changeServiceContentEdit"/>
                    </template>
                </el-table-column>
                 <el-table-column label="服务内容类型" style="height:65px;" align="center" :show-overflow-tooltip="true"> 
                    <template slot-scope="scope">
                        <span  v-if="(!scope.row.editeFlage && scope.row.itemType==0)" style="margin-left: 10px">拍照</span>
                        <span  v-else-if="(!scope.row.editeFlage && scope.row.itemType==1)" style="margin-left: 10px">异常报告</span>
                        <el-select v-model="scope.row.itemType" v-if="scope.row.editeFlage" style="width:120px;" placeholder="请选择服务类型" @change="changeServiceTypeEdit">
                            <el-option
                                v-for="item in serviceItemTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width=250 align="center" style="height:65px;">
                    <template slot-scope="scope" >
                        <el-button type="info" size="mini" v-if="!scope.row.editeFlage" @click="handleDetailServiceItem(scope.$index, scope.row)">详情</el-button>
                        <el-button type="warning" size="mini" v-if="!scope.row.editeFlage" @click="handleEditServiceItem(scope.$index, scope.row)">修改</el-button>
                        <el-button size="mini" type="success" v-if="scope.row.editeFlage" @click="handleSaveServiceItem(scope.$index,scope.row)">保存</el-button>
                        <!-- 添加一个取消按钮 -->
                        <el-button type="mini" size="mini"  v-if="scope.row.editeFlage" @click="cancalServiceItem(scope.$index, scope.row)">取消</el-button>
                        <el-button type="danger" size="mini" @click="handleDeleteServiceItem(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button :size="size" type="primary" @click.native="serviceProcessDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 新增服务流程子项目dialog模态框-->
        <el-dialog class="serviceItemdialog" title="服务内容" width="30%" :visible.sync="serviceItemDialogVisible" :close-on-click-modal="false" @close="closeDialogResetServiceItem">
            <el-form :model="serviceItemForm" label-width="140px" :rules="serviceItemRules" ref="serviceItemForm" :size="size" label-position="right">
                <el-form-item label="服务名称:" prop="itemName">
				    <el-input v-model.trim="serviceItemForm.itemName" auto-complete="off" placeholder="请输入服务名称" style="width:80%"></el-input>
			    </el-form-item>
                <el-form-item label="服务类型:" prop="itemType">
                    <el-select v-model="serviceItemForm.itemType" placeholder="请选择服务类型" style="width:80%">
                        <el-option
                            v-for="item in serviceItemTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button :size="size" @click.native="serviceItemDialogVisible = false">取消</el-button>
                <el-button :size="size" type="primary" @click.native="submitserviceItemForm" >确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增异常报告dialog模态框-->
        <el-dialog class="exceptionReportingdialog" title="异常报告" width="35%" :visible.sync="exceptionReportingDialogVisible" :close-on-click-modal="false" @close="closeDialogResetException">
            <el-form :model="exceptionReportingForm" label-width="120px" :rules="exceptionReportingRules" ref="exceptionReportingForm" :size="size" label-position="right">
                <el-form-item label="异常报告内容:" prop="reportItemContent">
                    <el-col :span=16>
                        <el-input v-model.trim="exceptionReportingForm.reportItemContent" auto-complete="off" placeholder="请输入异常报告内容" style="width:80%"></el-input>
			        </el-col>
                    <el-col :span=8 align="right">
                        <kt-button icon="el-icon-circle-plus" label="新增" type="primary" @click="addAbnormalReport"/>
                    </el-col>
                </el-form-item>
            </el-form>
            <el-table :data="reportItemDtos"  style="width:100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
                <el-table-column label="异常报告内容" style="height:65px;" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span  v-if="!scope.row.editeFlage" style="margin-left: 10px">{{ scope.row.reportItemContent }}</span>
                        <input type="text" class="el-input__inner" v-if="scope.row.editeFlage" style="width:120px;" v-model.trim="scope.row.reportItemContent"  placeholder="请输入" @input="changeServiceContentEdit"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width=200 align="center" style="height:65px;">
                    <template slot-scope="scope">
                        <el-button type="warning" size="mini" v-if="!scope.row.editeFlage" @click="handleEditExceptionReporting(scope.$index, scope.row)">修改</el-button>
                        <el-button size="mini" type="success" v-if="scope.row.editeFlage" @click="handleSaveExceptionReporting(scope.$index,scope.row)">保存</el-button>
                        <el-button type="danger" size="mini" @click="handleDeleteExceptionReporting(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button type="primary" :size="size" @click.native="exceptionReportingDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import KtButton from "@/components/KtButton"
export default {
    components:{
        KtButton,
    },
    data(){
        return {
            showOverflowTooltip:true,//是否单行显示，超出隐藏
            roleOptions:[],//角色的集合
            serviceId:"",//服务小项的服务id
            size:'medium',
            formLabelWidth:"110px",
            editLoading:false,
            serviceForm:{
                serviceName:"",
                serviceType:"",
                integral:"",
                remark:"",
                orderPut:[],
                orderRecv:[],
                orderConfirm:[],
                durationRecv:"",//接单超时时间
                durationIn:"",//签到超时时间
                durationService:"",//服务超时时间
                durationOut:"",//签退超时时间
                durationConfirm:"",//确认超时时间
            },//服务项目
            serviceRules:{
                serviceName: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                    {min:1, max:15, message: '长度在1到15位的字符'},
                ],
                serviceType: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                integral: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                    {min:1, max:3, message: '长度在1到3位的数字'},
                    { pattern: /^[0-9]+$/, message: '请输入由数字组成的字符' },
                ],
                remark: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                    { min: 1, max:50,  message: '长度在 1到 50 个字符', },
                ],
                orderPut: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                orderRecv: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                orderConfirm: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                durationRecv: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                durationIn: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                // durationService: [
                //     {required: true, message: '不能为空', trigger: 'change'},
                // ],
                durationOut: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
                durationConfirm: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
            },
            stepActive:0,//步骤条激活的状态
            serviceTypeNameShow:false,
            serviceTypeShow:false,
            integralShow:false,
            remarkShow:false,
            checkboxOrderPutShow:false,//下单的checkbox是否被选中
            checkboxOrderRecvShow:false,//接单的checkbox是否被选中
            checkboxOrderConfirmShow:false,//确认的checkbox是否被选中
            selectDurationRecvShow:false,//接单的超时时长是否有值
            selectDurationInShow:false,//签到超时时长是否有值
            selectDurationServiceShow:false,//服务超时超时时长是否有值
            selectDurationOutShow:false,//服务超时超时时长是否有值
            selectDurationConfirmShow:false,//确认超时超时时长是否有值
            serviceTypeNameOptions: [],
            serviceTypeOptions: [],
            overTimeOptions:[],//超时时长
            receivingOrderoverTimeOptions:[],//接单超时时长
            serviceProcessList:[],//巡查服务的集合 
            serviceProcessForm:{},//巡查服务过程
            serviceProcessDialogVisible:false,//巡查服务过程界面是否显示
            serviceProcessRules:{//巡查服务报告过程的rules
               
            },
            serviceItemTypeOptions: [],//服务子项目类型
            serviceItemForm:{},//服务子项目
            serviceItemDialogVisible:false,//服务子项目界面是否显示
            serviceItemRules:{//服务子项目的rules
                itemName: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                    {min:1, max:20, message: '长度在1到20个字符'},
                ],
                itemType: [
                    {required: true, message: '不能为空', trigger: 'change'},
                ],
            },
            exceptionReportingForm: {
                reportItemContent:""
            },//异常报告  
            editBeforeReportItemDtos:{},//异常报告点击修改前的数据
			exceptionReportingDialogVisible: false, //异常报告界面是否显示
			exceptionReportingLoading: false,//异常报告提交按钮loading
            exceptionReportingRules: {//异常报告的rules
                reportItemContent: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                    {min:1, max:20, message: '长度在1到20个字符'},
                ],
            },
            reportItemDtos:[],//异常报告table集合
            itemOrder:"",
            serviceItemId:"",
            EditServiceItem:"",  //将点击修改的这一列数据变成字符串保存用于取消按钮  by xiang 
            isDisabled:false, //控制button按钮的是否可用 by xiang 
        }
    },
    methods:{
        goBack(){
            console.log("返回上层");
            bus.$emit('close_current_tags');
        },
        //关闭服务流程子项目dialog清除验证
        closeDialogResetServiceItem(){
            this.$refs.serviceItemForm.resetFields();//移除校验结果并重置字段值
        },
        //关闭异常报告的dialog清除验证
        closeDialogResetException(){
            this.$refs.exceptionReportingForm.resetFields();//移除校验结果并重置字段值
        },
        //填写服务项目名称
        changeServiceTypeName(val){
            console.log(val);
            val !=null ? this.serviceTypeNameShow=true : this.serviceTypeNameShow=false;
            this.changeStep()
        },
        //选取服务类型
        changeServiceType(val){
            console.log(val);
            val !=null ? this.serviceTypeShow=true : this.serviceTypeShow=false;
            this.changeStep()
        },  
        //填写积分
        blurIntegral(){
            console.log(this.serviceForm.integral)
            this.serviceForm.integral !=null ? this.integralShow=true : this.integralShow=false;
            this.changeStep()
        },
        //填写卑职
        blurRemark(){
            console.log(this.serviceForm.remark)
            this.serviceForm.remark !='' ? this.remarkShow=true : this.remarkShow=false;
            this.changeStep()
        },
        //下单人checkbox选取
        handleCheckedOrderPut(val){
            console.log(val);
            this.serviceForm.orderPut=val;
            val.length>0 ? this.checkboxOrderPutShow=true : this.checkboxOrderPutShow=false;
            this.changeStep()
        },
        //接单人checkbox选取
        handleCheckedOrderRecv(val){
            console.log(val);
            this.serviceForm.orderRecv=val;
            val.length>0 ? this.checkboxOrderRecvShow=true : this.checkboxOrderRecvShow=false;
            this.changeStep()
        },
        //确认人checkbox选取
        handleCheckedOrderConfirm(val){
            console.log(val);
            this.serviceForm.orderConfirm=val;
            val.length>0 ? this.checkboxOrderConfirmShow=true : this.checkboxOrderConfirmShow=false;
            this.changeStep()
        },
        //接单超时时长select
        changeDurationRecv(val){
            console.log(val);
            val ? this.selectDurationRecvShow=true : this.selectDurationRecvShow=false;
            this.changeStep()
        },
        //签到超时时长select
        changeDurationIn(val){
            console.log(val);
            val ? this.selectDurationInShow=true : this.selectDurationInShow=false;
            this.changeStep()
        },
        //服务超时时长select
        changeDurationService(val){
            console.log(val);
            val ? this.selectDurationServiceShow=true : this.selectDurationServiceShow=false;
            this.changeStep()
        },
        //签退超时时长的select
        changeDurationOut(val){
            console.log(val);
            val ? this.selectDurationOutShow=true : this.selectDurationOutShow=false;
            this.changeStep()
        },
        //确认超时时长的select
        changeDurationConfirm(val){
            console.log(val);
            val ? this.selectDurationConfirmShow=true : this.selectDurationConfirmShow=false;
            this.changeStep()
        },
        //控制步骤条的颜色变化
        changeStep(){
            console.log(this.serviceTypeNameShow,this.serviceTypeShow,this.integralShow,this.remarkShow)
            var status=this.serviceTypeNameShow && this.serviceTypeShow && this.integralShow && this.remarkShow
            console.log(status,this.checkboxOrderPutShow,this.selectDurationRecvShow,this.serviceProcessList)
            if(status){
                this.stepActive=1
                console.log(status && this.checkboxOrderPutShow)
                if(this.checkboxOrderPutShow){
                    this.stepActive=2
                    if(this.checkboxOrderRecvShow && this.selectDurationRecvShow){
                        this.stepActive=3 
                        if(this.selectDurationInShow){
                            this.stepActive=4
                            if(this.serviceProcessList.length>0){//by guo 修改  将另一个判断条件 && this.selectDurationServiceShow 去掉
                                this.stepActive=5
                                if(this.selectDurationOutShow){
                                   this.stepActive=6 
                                    if(this.selectDurationConfirmShow && this.checkboxOrderConfirmShow){
                                        this.stepActive=7  
                                    }else{
                                        this.stepActive=6 
                                    }
                                }else{
                                    this.stepActive=5
                                }
                            }else{
                                this.stepActive=4
                            }
                        }else{
                           this.stepActive=3 
                        }
                    }else{
                        this.stepActive=2
                    }
                }else{
                    this.stepActive=1 
                }
            }else{
                this.stepActive=0
            }
            console.log(this.stepActive)
        },
        //巡查服务流程的模态框显示
        addserviceProcessDialog(){
            this.serviceProcessDialogVisible = true;
            this.getItemService();
        },
        //服务内容模态框显示
        addProcess(){
            this.serviceItemDialogVisible = true;
            this.serviceItemForm={
                itemName: "",
                itemType: ""
            }
        },
        //提交服务
        submitService(){
            console.log("提交服务--------------------")
            this.$refs.serviceForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        //判断服务内容不能为空才能提交数据
                        console.log(this.serviceProcessList.length)
                        if(this.serviceProcessList.length>0){
                            this.editLoading = true
                            let params = Object.assign({}, this.serviceForm)
                            params.orderPut=params.orderPut.join(',');
                            params.orderRecv=params.orderRecv.join(',');
                            params.orderConfirm=params.orderConfirm.join(',');
                            console.log(this.serviceId,params)
                            //this.serviceId==true为修改的url  this.operation==false为新增的url
                            let url=''
                            this.serviceId ? url='omc/service/edit' : url='omc/service/add'
                            console.log(url)
                            this.$postJson(url, params).then((res) => {
                                console.log(res)
                                if(res.code == 200) {
                                    this.$message({ message: '操作成功', type: 'success' })
                                    this.$refs['serviceForm'].resetFields()
                                    this.stepActive=0
                                    this.presentServiceItemData(res.result.id);
                                    setTimeout(()=>{
                                        this.$router.push({path:'/volunteerservicelist'});//编程式导航跳转
                                    },1000)
                                } else {
                                    this.$message({message: '操作失败, ' + res.message, type: 'error'})
                                }
                                this.editLoading = false
                            })
                        }else{
                            this.$message({message: '服务内容不能为空', type: 'error'})
                        }
                    })
                }
            })
        },
        //生成唯一键
        genID(length){
            return Number(Math.random().toString().substring(3,length) + Date.now()).toString(36);
        },
        //新增服务内容子项目缓存数据到本地sessionStorage
        submitserviceItemForm(){
            console.log("提交服务内容子项目---------")
            console.log(this.serviceProcessList.length,this.genID(0))
            this.$refs.serviceItemForm.validate((valid) => {
				if (valid) {
                    let params = Object.assign({}, this.serviceItemForm)
                    console.log(params)
                    var paramsList=[]
                    if(this.serviceId){
                        params.reportItemDtos=[]
                        params.serviceId=this.serviceId
                        paramsList.push(params)
                        this.$postJson("omc/serviceItem/add", paramsList).then((res) => {
                            console.log(res)
                            this.editLoading = false
                            if(res.code == 200) {
                                // this.$message({ message: '操作成功', type: 'success' })
                                this.serviceItemDialogVisible = false
                            } else {
                                this.$message({message: '操作失败, ' + res.message, type: 'error'})
                            }
                                this.getItemService();
                        })
                    }else{
                        params.itemOrder=this.genID(8)
                        this.serviceItemDialogVisible = false
                        console.log(this.serviceProcessList.length,"----------------------");
                        if(this.serviceProcessList.length>0){
                            for(var i=0;i<this.serviceProcessList.length;i++){
                                console.log(this.serviceProcessList[i])
                                if(this.serviceProcessList[i].itemName==params.itemName){
                                    return this.$message({message: '操作失败,服务内容名称已经存在',type:'error'}) 
                                }
                            }
                            this.serviceProcessList.push(params);
                        }else{
                            this.serviceProcessList.push(params);
                        }
                        // this.$message({ message: '操作成功', type: 'success' })
                        let serviceProcessList=this.serviceProcessList;
                        serviceProcessList=JSON.stringify(serviceProcessList)
                        sessionStorage.setItem("serviceProcessList",serviceProcessList)
                        this.getCatchData()
                        this.$refs['serviceItemForm'].resetFields()
                    }     
                }
            })
        },
        //新增提交服务内容子项目数据到后端
        presentServiceItemData(info){
            let sessionStorageService=sessionStorage.getItem("serviceProcessList");
            let sessionStorageReportItemDtos=sessionStorage.getItem("reportItemDtos");
            sessionStorageService=JSON.parse(sessionStorageService);
            sessionStorageReportItemDtos=JSON.parse(sessionStorageReportItemDtos);
            var params=[]
            if(sessionStorageService){
                sessionStorageService.forEach((item,index)=>{
                    var sessionStorageServiceObj={};
                    sessionStorageServiceObj.serviceId=info
                    sessionStorageServiceObj.itemOrder=item.itemOrder
                    sessionStorageServiceObj.itemName=item.itemName
                    sessionStorageServiceObj.itemType=item.itemType
                    if(sessionStorageReportItemDtos){
                        var newArr=[];//这里数组不能放到下面的循环里面，就算有多条，否则每次页只有一条数据
                        sessionStorageReportItemDtos.forEach((temp,i)=>{
                            if(sessionStorageServiceObj.itemOrder==temp.itemOrder){
                                newArr.push(temp)
                                sessionStorageServiceObj.reportItemDtos=newArr 
                            }
                        })
                    }else{
                        sessionStorageServiceObj.reportItemDtos=[]
                    }
                    params.push(sessionStorageServiceObj)
                    params.forEach((item,index)=>{
                        console.log(item)
                        item.itemOrder=''
                    })
                })
                console.log(params);
                this.$postJson("omc/serviceItem/add", params).then((res) => {
                    console.log(res)
                    this.editLoading = false
                    if(res.code == 200) {
                        // this.$message({ message: '操作成功', type: 'success' })
                        this.serviceItemDialogVisible = false
                        sessionStorage.removeItem("serviceProcessList")
                        sessionStorage.removeItem("reportItemDtos")
                    } else {
                        this.$message({message: '操作失败, ' + res.message, type: 'error'})
                    }
                    this.getItemService();
                })
            }
        },

        changeServiceContentEdit(val){
            console.log(val.data);
        },
        changeServiceTypeEdit(val){
            console.log(val);
        },
        //服务内容子项目修改 切换 保存
        handleEditServiceItem(index,row){
            console.log(index,row);
            row.editeFlage=true; 
            this.isDisabled = true;
            this.EditServiceItem = JSON.stringify(row) //将点击修改的这一列数据变成字符串保存用于取消按钮  by xiang
        },

        //服务内容子项目添加 [取消修改] by xiang 
        cancalServiceItem(index,row){
            let cancalEdit = JSON.parse(this.EditServiceItem)
            cancalEdit.editeFlage = false
            this.serviceProcessList.splice(index,1,cancalEdit)

            //根据editeFlage的状态改变isDisabled的状态  by xiang
                        let disabledStatus = this.serviceProcessList.every(item=>{
                            return item.editeFlage == false
                        })
                        if(disabledStatus){
                            this.isDisabled = false;
                        }
        },

        //服务内容子项目修改保存提交数据
        handleSaveServiceItem(index,row){
            console.log(index,row);
            if(row.itemName !=""){
                if(row.itemName.length>0 && row.itemName.length<=20){
                    let params={};
                    params.itemName=row.itemName;
                    params.itemType=row.itemType;
                    //通过服务serviceId去判断是提交数据到后台，还是缓存数据到sessionStorage
                    if(row.serviceId){
                        params.id=row.id;
                        params.serviceId=row.serviceId;
                        this.$postJson("omc/serviceItem/edit", params).then((res) => {
                            console.log(res)
                            if(res.code == 200) {
                                this.$message({ message: '操作成功', type: 'success' })
                                //直接修改数据源 
                            } else {
                                this.$message({message: '操作失败, ' + res.message, type: 'error'})
                            }
                            row.editeFlage=false;
                            // this.isDisabled = false;

                            //问题： 修改其他的导致全部变成不可编辑状态  
                            //解决：不需要重新渲染页面 by xiang 
                             //this.getItemService();

                             //根据editeFlage的状态改变isDisabled的状态  by xiang
                        let disabledStatus = this.serviceProcessList.every(item=>{
                            return item.editeFlage == false
                        })
                        if(disabledStatus){
                            this.isDisabled = false;
                        }
                        })
                    }else{
                        params.itemOrder=row.itemOrder;
                        if(this.serviceProcessList.length>0){
                            for(var i=0;i<this.serviceProcessList.length;i++){
                                console.log(this.serviceProcessList[i])
                                if(this.serviceProcessList[i].itemName==params.itemName && this.serviceProcessList[i].itemOrder!=params.itemOrder){
                                    return this.$message({message: '操作失败,服务内容名称已经存在',type:'error'}) 
                                }
                            }
                            this.serviceProcessList.splice(index,params);
                        }else{
                            this.serviceProcessList.splice(index,params);
                        }
                        this.$message({ message: '操作成功', type: 'success' })
                        let serviceProcessList=this.serviceProcessList;
                        serviceProcessList=JSON.stringify(serviceProcessList)
                        sessionStorage.setItem("serviceProcessList",serviceProcessList)
                          //问题： 修改其他的导致全部变成不可编辑状态  
                            //解决：不需要重新渲染页面 by xiang 
                        // this.getCatchData()
                        row.editeFlage=false;

                        //根据editeFlage的状态改变isDisabled的状态  by xiang
                        let disabledStatus = this.serviceProcessList.every(item=>{
                            return item.editeFlage == false
                        })
                        if(disabledStatus){
                            this.isDisabled = false;
                        }
                    } 
                }else{
                    this.$message({message: '长度在1到20个字符', type: 'error'})
                }  
            }else{
                this.$message({message: '服务内容名称不能为空', type: 'error'})
            } 
        },
        //服务内容子项目删除
        handleDeleteServiceItem(index,row){
            console.log(index,row);
            this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                console.log("啊啊啊啊啊")
                 //通过id去判断是提交数据到后台，还是删除本地的缓存数据sessionStorage
                if(row.id){
                    let serviceItemId=row.id;
                    this.$postJson('omc/serviceItem/deleteById/'+serviceItemId,).then((res)=>{
                        console.log(res);
                        this.getItemService();
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                    })   
                }else{
                    this.$message({ message: '删除成功', type: 'success' })
                    this.serviceProcessList.splice(index,1);
                    let serviceProcessList=this.serviceProcessList;
                    serviceProcessList=JSON.stringify(serviceProcessList)
                    sessionStorage.setItem("serviceProcessList",serviceProcessList)
                    this.getCatchData()
                    let localReport=sessionStorage.getItem("reportItemDtos")
                    localReport=JSON.parse(localReport)
                    console.log(localReport)
                    localReport.forEach(item=>{
                        //过滤条件
                        if(item.itemOrder==row.itemOrder){
                            localReport.splice(index,1) 
                            console.log(localReport)
                        }
                    })
                    console.log(localReport)
                    localReport=JSON.stringify(localReport);
                    sessionStorage.setItem("reportItemDtos",localReport);
                } 
            })
        },

        //服务内容子项目详情
        handleDetailServiceItem(index,row){
            console.log(index,row);
            this.reportItemDtos=[];//点击详情先清空this.reportItemDtos
            //判断服务内容类型itemType为0时是拍照 itemType为1时是异常报告
            if(row.itemType==1){
                this.exceptionReportingDialogVisible=true;
                this.itemOrder=row.itemOrder;
                this.serviceItemId=row.id;
                console.log(this.itemOrder)
                let localReportItemDtos=sessionStorage.getItem("reportItemDtos")
                 console.log(localReportItemDtos)
                if(localReportItemDtos){
                    localReportItemDtos=JSON.parse(localReportItemDtos);
                    localReportItemDtos.forEach((item,index)=>{
                        console.log(item.itemOrder)
                        console.log(this.itemOrder)
                        if(item.itemOrder==this.itemOrder){
                            this.reportItemDtos.push(item)
                            console.log(this.itemOrder)
                            this.getCatchReportingData(this.itemOrder)
                            return;
                        }
                    })
                }
                this.getExceptionReporting(row.id);
            }else{
                this.$message({message: '该服务类型没有详情！' , type: 'error'})
            } 
        },
        //新增异常报告
        addAbnormalReport(){
            console.log("新增异常报告");
            console.log(this.reportItemDtos.length)
            this.$refs.exceptionReportingForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        let params = Object.assign({}, this.exceptionReportingForm)
                        params.reportOrder=this.reportItemDtos.length+1
                        params.itemOrder=this.itemOrder
                        console.log(params)
                        console.log(this.serviceId)
                        if(this.serviceId){
                            params.serviceItemId=this.serviceItemId;
                             this.$postJson("omc/reportItem/add", params).then((res) => {
                                console.log(res)
                                if(res.code == 200) {
                                    this.$message({ message:'操作成功', type: 'success' })
                                } else {
                                    this.$message({message: '操作失败, ' + res.message, type: 'error'})
                                }
                                this.getExceptionReporting(this.serviceItemId);
                                this.$refs['exceptionReportingForm'].resetFields()
                                sessionStorage.removeItem("reportItemDtos")
                            })
                        }else{
                            console.log(sessionStorage.getItem("reportItemDtos"))
                            var reportItemDtossessionStorage=sessionStorage.getItem("reportItemDtos")
                            if(reportItemDtossessionStorage==null){//判断缓存数据是否存在，不存在就设置缓存
                                this.reportItemDtos.push(params)
                                let reportItemDtos=this.reportItemDtos;
                                reportItemDtos=JSON.stringify(reportItemDtos)
                                sessionStorage.setItem("reportItemDtos",reportItemDtos)
                            }else{//缓存数据本来就存在的话，就直接把值添加到该缓存数据中
                                reportItemDtossessionStorage=JSON.parse(reportItemDtossessionStorage);
                                if(this.reportItemDtos.length>0){
                                    for(var i=0;i<this.reportItemDtos.length;i++){
                                        console.log(this.reportItemDtos[i])
                                        if(this.reportItemDtos[i].reportItemContent==params.reportItemContent){
                                            return this.$message({message: '操作失败,异常报告内容已经存在',type:'error'}) 
                                        }
                                    }
                                }
                                reportItemDtossessionStorage.push(params);
                                reportItemDtossessionStorage=JSON.stringify(reportItemDtossessionStorage)
                                sessionStorage.setItem("reportItemDtos",reportItemDtossessionStorage)
                            }
                            this.getCatchReportingData(params.itemOrder);
                            this.$refs['exceptionReportingForm'].resetFields()
                            this.$message({ message: '操作成功', type: 'success' })
                        }
                    }).catch((res) => {
                        this.$message({
                            type: 'info',
                            message: '取消新增',
                        });
                    });
                }
            })
        },
        //修改异常报告  切换到保存提交
        handleEditExceptionReporting(index,row){
            console.log(index,row);
            row.editeFlage=true; 
            this.editBeforeReportItemDtos=Object.assign({}, row)
            console.log(this.editBeforeReportItemDtos)
        },
        //修改异常报告 点击保存提交数据到后端
        handleSaveExceptionReporting(index,row){
            console.log(index,row);
            if(row.reportItemContent !=""){
                console.log(row.reportItemContent.length)
                if(row.reportItemContent.length>0 && row.reportItemContent.length<=20){
                    let params={};
                    params.reportItemContent=row.reportItemContent;
                    params.reportOrder=row.reportOrder;
                    params.editeFlage=row.editeFlage;
                    params.itemOrder=row.itemOrder;
                    params.index=row.index;
                    //通过服务serviceId去判断是提交数据到后台，还是缓存数据到sessionStorage
                    if(row.serviceItemId){
                        params.id=row.id;
                        params.serviceItemId=row.serviceItemId;
                        this.$postJson("omc/reportItem/edit", params).then((res) => {
                            console.log(res)
                            if(res.code == 200) {
                                this.$message({ message: '操作成功', type: 'success' })
                            } else {
                                this.$message({message: '操作失败, ' + res.message, type: 'error'})
                            }
                            row.editeFlage=false;
                            this.getExceptionReporting(row.serviceItemId);
                        })
                    }else{
                        let localReport=sessionStorage.getItem("reportItemDtos")
                        localReport=JSON.parse(localReport)
                        console.log(localReport)
                        //先操作每一个详情的异常报告表格的数据修改
                        if(this.reportItemDtos.length>0){
                            for(var i=0;i<this.reportItemDtos.length;i++){
                                console.log(this.reportItemDtos[i])
                                if(this.reportItemDtos[i].reportItemContent==params.reportItemContent && this.reportItemDtos[i].index!=params.index){
                                    return this.$message({message: '操作失败,异常报告内容已经存在',type:'error'}) 
                                }
                            }
                            this.reportItemDtos.splice(index,params);
                        }else{
                            this.reportItemDtos.splice(index,params);
                        }
                        //再操作缓存的数据的修改
                        localReport.forEach((item,index)=>{
                            //过滤条件
                            console.log(item.itemOrder,this.editBeforeReportItemDtos.itemOrder,item.reportItemContent,this.editBeforeReportItemDtos.reportItemContent,item.reportOrder,this.editBeforeReportItemDtos.reportOrder)
                            if(item.reportItemContent==this.editBeforeReportItemDtos.reportItemContent && index==this.editBeforeReportItemDtos.index){
                                localReport.splice(index,1,params) //替换当前的数据
                                console.log(localReport)
                            }
                        })
                        console.log(localReport)
                        localReport=JSON.stringify(localReport);
                        sessionStorage.setItem("reportItemDtos",localReport);
                        row.editeFlage=false;
                        this.getCatchReportingData(row.itemOrder);
                        // this.$message({ message: '操作成功', type: 'success' })
                    } 
                }else{
                    this.$message({message: '长度在1到20个字符', type: 'error'})
                }    
            }else{
                this.$message({message: '异常报告内容不能为空', type: 'error'})
            }  
        },
        //删除异常报告
        handleDeleteExceptionReporting(index,row){
            console.log(index,row);
            this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                 //通过id去判断是提交数据到后台，还是删除本地的缓存数据sessionStorage
                if(row.id){
                    let reportItemId=row.id;
                    let serviceItemId=row.serviceItemId
                    this.$postJson('omc/reportItem/deleteById/'+reportItemId,).then((res)=>{
                        console.log(res);
                        this.getExceptionReporting(serviceItemId);
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                    })   
                }else{
                    this.getCatchReportingData(row.itemOrder);
                    let localReport=sessionStorage.getItem("reportItemDtos")
                    localReport=JSON.parse(localReport)
                    console.log(localReport)
                    localReport.forEach((item,index)=>{
                        //过滤条件
                        if(item.reportItemContent==row.reportItemContent && item.itemOrder==row.itemOrder){
                            localReport.splice(index,1) 
                            console.log(localReport)
                        }
                    })
                    console.log(localReport)
                    localReport=JSON.stringify(localReport);
                    sessionStorage.setItem("reportItemDtos",localReport);
                    row.editeFlage=false;
                    this.getCatchReportingData(row.itemOrder);
                    this.$message({ message: '删除成功', type: 'success' })
                } 
            }).catch(() => {
                console.log("==========")
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        reset(){
            this.$refs.serviceForm.resetFields();//移除校验结果并重置字段值
            this.stepActive=0;
            this.serviceTypeNameShow=false;
            this.serviceTypeShow=false;
            this.frequencyShow=false;
            this.integralShow=false;
            this.remarkShow=false;
            this.radioOneShow=false;
            this.radioTwoShow=false;
            this.radioThreeShow=false;
            //重置服务内容 by xiang
             this.serviceProcessList =[]

        },

        //查询服务子项目的table数据
        getItemService(){
            let serviceId=this.serviceId;
            console.log(serviceId);
            if(serviceId){
                this.$postJson('omc/serviceItem/queryListByServiceId/'+serviceId).then((res) => {
                    console.log(res)
                    if(res.result !=null){
                        var serviceItemArr=[];
                        res.result.forEach((item,index)=>{
                            var serviceItemObj={};
                            serviceItemObj.editeFlage = false;
                            serviceItemObj.index = index;
                            serviceItemObj.id=item.id;
                            serviceItemObj.serviceId=item.serviceId;
                            serviceItemObj.itemContent=item.itemContent;
                            serviceItemObj.itemOrder=item.itemOrder;
                            serviceItemObj.itemName=item.itemName;
                            serviceItemObj.itemType=item.itemType;
                            serviceItemArr.push(serviceItemObj);
                        })
                        this.serviceProcessList=serviceItemArr;
                        console.log(this.serviceProcessList);
                    }
                })
            }
        },
        //查询异常报告的table数据
        getExceptionReporting(id){
            let serviceItemId=id;
            if(serviceItemId){
                this.$postJson('omc/reportItem/queryListByServiceItemId/'+serviceItemId).then((res) => {
                    console.log(res);
                    if(res.result !=null){
                        var exceptionReportingArr=[];
                        res.result.forEach((item,index)=>{
                            if(serviceItemId==item.serviceItemId){
                                var exceptionReportingObj={};
                                exceptionReportingObj.editeFlage = false;
                                exceptionReportingObj.index = index;
                                exceptionReportingObj.id=item.id;
                                exceptionReportingObj.serviceItemId=item.serviceItemId;
                                exceptionReportingObj.reportItemContent=item.reportItemContent;
                                exceptionReportingObj.reportOrder=item.reportOrder;
                                exceptionReportingArr.push(exceptionReportingObj);
                            }
                        })
                        this.reportItemDtos=exceptionReportingArr;
                        console.log(this.reportItemDtos);
                    }
                })
            }
        },
        // 修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if(rowIndex %2==0){
                 return 'background-color: #efefef'
            }else{
                 return 'background-color: #f9f9f9'
            } 
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color:#bee1f4;color:#6f7075;font-weight: 500;'
            }
        },
        //初始化服务类型名称
        initialServiceTypeNames(){
            var serviceTypeNames = ["问候", "送餐", "保洁", "医疗"]
            for(var i = 0; i <  serviceTypeNames.length; i++) {
                var item = {}
                item.value = i
                item.label =  serviceTypeNames[i]
                this.serviceTypeNameOptions.push(item)
            }
        },
        //初始化服务类型
        initialServiceTypes(){
            var serviceTypes = ["小时", "次"]
            for(var i = 0; i <  serviceTypes.length; i++) {
                var item = {}
                item.value = i
                item.label =  serviceTypes[i]
                this.serviceTypeOptions.push(item)
            }
        },
         //初始化超时时长
        initialOverTimes(){
            for(var i=0;i<=240;i++){
                var item={}
                if(i % 5 == 0 && i>0){
                    item.value = i
                    item.label = i
                    this.overTimeOptions.push(item);
                }
            }
        },
        //初始化接单的超时时长
        initialReceivingOrderOverTimes(){
            for(var i=0;i<=240;i++){
                var item={}
                if(i % 5 == 0 && i>0){
                    item.value = i
                    item.label = i
                    this.receivingOrderoverTimeOptions.push(item);
                }
            }
        },
        //初始化服务子项目类型
        initialServiceItemTypes(){
            var serviceItemTypes = ["拍照", "异常报告"]
            for(var i = 0; i <  serviceItemTypes.length; i++) {
                var item = {}
                item.value = i
                item.label =  serviceItemTypes[i]
                this.serviceItemTypeOptions.push(item)
            }
        },
        //获取管理员角色信息
        queryRoleList(){
            let params={
                pageNum: 0,
	            pageSize: 0
            }
            this.$postJson("uac/role/queryListWithPage", params).then((res) => {
                console.log(res)
                this.roleOptions=res.result.list;
                console.log(this.roleOptions);
            })
        },
        //获取跳转传递过来的query值
        getRouteQueryInfo(){
            if(this.$route.query.res){//接收parmas传递的一个对象
                let data = JSON.parse(this.$route.query.res)
                data.serviceType == "小时" ? data.serviceType=0 : data.serviceType=1
                data.integral=data.integral+''
                switch(data.orderPut)
                {
                    case "超级管理员":
                        data.orderPut="admin";
                         break;  
                    case "志愿者":
                        data.orderPut="volunteer";
                        break;
                    default:
                        data.orderPut="";
                };
                switch(data.orderRecv)
                {
                    case "超级管理员":
                        data.orderRecv="admin";
                         break;  
                    case "志愿者":
                        data.orderRecv="volunteer";
                        break;
                    default:
                        data.orderRecv="";
                };
                switch(data.orderConfirm)
                {
                    case "超级管理员":
                        data.orderConfirm="admin";
                         break;  
                    case "志愿者":
                        data.orderConfirm="volunteer";
                        break;
                    default:
                        data.orderConfirm="";
                };
                console.log(data)
                this.serviceForm = Object.assign({}, data);
                var orderPutList=[];
                var orderRecvList=[];
                var orderConfirmList=[];
                orderPutList.push(data.orderPut);
                orderRecvList.push(data.orderRecv);
                orderConfirmList.push(data.orderConfirm);
                this.serviceForm.orderPut=orderPutList;
                this.serviceForm.orderRecv=orderRecvList;
                this.serviceForm.orderConfirm=orderConfirmList;
                this.serviceId=data.id
                console.log(this.serviceId)
            }
        },
        //获取缓存的serviceProcessList服务子项目集合
        getCatchData(){
            let serviceProcessList =sessionStorage.getItem("serviceProcessList")
            serviceProcessList=JSON.parse(serviceProcessList)
            var newServiceProcessList=[]
            if(serviceProcessList){
                serviceProcessList.forEach((item,index)=>{
                    let serviceProcessObj={}
                    serviceProcessObj.editeFlage = false;
                    serviceProcessObj.index = index;
                    serviceProcessObj.itemOrder=item.itemOrder
                    serviceProcessObj.itemName=item.itemName
                    serviceProcessObj.itemType=item.itemType
                    item.itemType==0 ? serviceProcessObj.itemContent="拍照" : serviceProcessObj.itemContent="异常报告"
                    newServiceProcessList.push(serviceProcessObj)
                })
                this.serviceProcessList=serviceProcessList ? newServiceProcessList : []
                console.log(this.serviceProcessList)
                this.changeStep();
            }
        },

        //获取缓存的reportItemDtos异常报告集合
        getCatchReportingData(dataInfo){
            console.log(dataInfo)
            let reportItemDtos =[]
            reportItemDtos =sessionStorage.getItem("reportItemDtos")
            reportItemDtos=JSON.parse(reportItemDtos)
            var newReportItemDtos=[]
            if(reportItemDtos){
                reportItemDtos.forEach((item,index)=>{
                    let reportItemDtosObj={}
                    if(dataInfo==item.itemOrder){
                        reportItemDtosObj.editeFlage = false;
                        reportItemDtosObj.index = index;
                        reportItemDtosObj.itemOrder=item.itemOrder
                        reportItemDtosObj.reportOrder=item.reportOrder
                        reportItemDtosObj.reportItemContent=item.reportItemContent
                        newReportItemDtos.push(reportItemDtosObj)
                    }
                })
                this.reportItemDtos=reportItemDtos ? newReportItemDtos : []
                console.log(this.reportItemDtos)
            }
        },
        //路由钩子判断页面从哪里跳转来，到那里去 然后清除sessionStorage的缓存数据
        beforeEach(){
            this.$router.beforeEach((to, from, next) => { //to:即将前往的页面,from:从哪个页面来,next:下一步操作
                console.log(to);
                console.log(from);
                if(from.path !='/volunteerserviceCompile'){
                    console.log('aaa');
                    //从其他页面跳转过来先清除缓存数据
                    sessionStorage.removeItem("serviceProcessList")
                    sessionStorage.removeItem("reportItemDtos")
                }else{
                   console.log('bbb');
                }
                next()
            });
        }
    },
    created(){
        this.initialServiceTypeNames();
        this.initialServiceTypes();
        this.initialServiceItemTypes();
        this.initialReceivingOrderOverTimes();
        this.initialOverTimes();
        this.getRouteQueryInfo();
    },
    mounted(){
        this.getRouteQueryInfo();
        this.getCatchData();
        this.queryRoleList();
        this.beforeEach();
        this.getCatchReportingData(this.itemOrder)
        this.getItemService();
    },
    watch: {
        'serviceProcessList': {
            handler(newValue, oldValue) {
    　　　　　　 for (let i = 0; i < newValue.length; i++) {
    　　　　　　　　  if (oldValue[i] != newValue[i]) {
    　　　　　　　　　　  console.log(newValue)
                        this.changeStep()
    　　　　　　　　  }
    　　　　　　}
    　　　　},
    　　　　deep: true
    　　},
    }
}
</script>
<style lang="scss" scoped>
     .page-container{
        height:500px;
        display: flex;
        flex-direction: column;
        background: #fff;
        .demo-form-inline{
            height:60px;
        }
        .content{
            margin:0px 0 30px 0;
            width:100%;
            flex:1;
            background: #fff;
            table {
                width:100%;
                margin:10px auto;
                border-collapse:collapse;
                border:1px solid #cccccc;
            }
            td {
                border:1px solid #cccccc;
            }
            .serviceTypeName,.serviceType,.integral,.remark,.checkbox,.selectItem{
                position: relative;
            }
            ::deep .serviceTypeName .el-form-item__error{
                position: absolute;
                left:110px;
                top:98%;
            }
            ::deep .serviceType .el-form-item__error{
                position: absolute;
                left:115px;
                top:98%;
            }
            ::deep .integral .el-form-item__error{
                position: absolute;
                left:110px;
                top:98%;
            }
            ::deep .remark .el-form-item__error{
                position: absolute;
                left:115px;
                top:98%;
            }
            ::deep .checkbox .el-form-item__error{
                position: absolute;
                top:55%;
            }
            ::deep .selectItem .el-form-item__error{
                position: absolute;
                top:100%;
            }
        }
        // ::deep深度作用选择符
        ::deep .el-dialog__header{
            text-align: left;
            background: rgb(238, 231, 231);
            border-bottom: 2px solid rgb(211, 207, 207);
        }
        //服务内容的 dialog
        @media screen and (max-width: 1350px){
            ::deep .serviceProcessdialog .el-dialog{
                width:60% !important;
            }
        }
        @media screen and (max-width: 1100px){
            ::deep .serviceProcessdialog .el-dialog{
                width:90% !important;
            }
        }
        //新增服务内容的dialog模态框
        ::deep .serviceProcessdialog .el-dialog .el-dialog__body{
            padding:10px 20px 30px 20px ;
            height:400px;
            overflow-y: scroll;
        }
        ::deep .serviceForm .el-form-item{
            margin-bottom: 0px;
        }
        //新增异常报告的dialog模态框
        ::deep .exceptionReportingdialog .el-dialog .el-dialog__body{
            padding:10px 20px 30px 20px ;
            height:400px;
            overflow-y: scroll;
        }
        //服务子项目 dialog
        @media screen and (max-width: 1350px){
            ::deep .serviceItemdialog .el-dialog{
                width:50% !important;
            }
        }
        @media screen and (max-width: 1300px){
            ::deep .serviceItemdialog .el-dialog{
                width:58% !important;
            }
        }
        @media screen and (max-width: 1250px){
            ::deep .serviceItemdialog .el-dialog{
                width:60% !important;
            }
        }
        //异常报告 dialog
        @media screen and (max-width: 1350px){
            ::deep .exceptionReportingdialog .el-dialog{
                width:45% !important;
            }
        }
        @media screen and (max-width: 1100px){
            ::deep .exceptionReportingdialog .el-dialog{
                width:60% !important;
            }
        }
    }
</style>
